
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ToolContainer } from "../../contents";
import { EditingDocument } from "../../EditingDocument";
import PaneMixin from "./PaneMixin.vue";

@Component({
  components: {
    ToolContainer,
  }
})
export default class SubToolContainablePaneMixin extends Mixins(PaneMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  @Prop({ default: false })
  hasAdditionalComments: boolean;

  get tabs(): any[] {
    return Enumerable.from([
      (this.isEmbedded || !this.hasComments) ? null : ToolContainer.Tabs.comment,
      (this.isCreatedReportRestricted || this.isEmbedded) ? null : ToolContainer.Tabs.createdReport,
      ToolContainer.Tabs.alert,
      ToolContainer.Tabs.debug,
    ])
    .where(t => !!t)
    .toArray();
  }

  get defaultSelectedTab(): any {
    return this.$configuration.behavior.document.editor.panes.right.defaultSelectedTab in ToolContainer.Tabs
           ? ToolContainer.Tabs[this.$configuration.behavior.document.editor.panes.right.defaultSelectedTab]
           : null;
  }

  get hasComments(): boolean {
    // コメントタブを表示すべきかは外側で判定.(生成してから「いらなかった.」というわけにはいかないので.)
    // 標準実装コメントは一時保存メモ.追加がある場合はここに条件追加する事.
    // 追加実装コメント有無は利用側からプロパティで渡す.(別途コンテンツをslotで渡してるがslotはまずそれを持つコンポーネントが生成されないと呼ばれないため.)
    return this.isDocumentTemporarySaved
        || this.hasAdditionalComments
        || this.hasExternalComments;
  }

  get hasExternalComments(): boolean {
    const externalComments = this.readPropertyOrDefault(d => d.attributes.externalComments, []);
    return externalComments && externalComments.length > 0;
  }

  get isDocumentTemporarySaved(): boolean {
    return this.readPropertyOrDefault(s => s.attributes.isTemporary, false);
  }

  get isCreatedReportRestricted(): boolean {
    return this.isToolsRestricted 
        && this.editingSource.restrictions.tools.createdReport.isDisabled;
  }
  
  get isToolsRestricted(): boolean {
    return this.editingSource
        && this.editingSource.restrictions
        && !!this.editingSource.restrictions.tools;
  }

}
